var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout"},[_c('NavBar'),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.isRouterAlive)?_c('router-view'):_vm._e()],1),_c('div',{staticClass:"footer",domProps:{"innerHTML":_vm._s(_vm.copyright)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }